import { render, staticRenderFns } from "./winningRecord.vue?vue&type=template&id=d621f0d2&scoped=true&"
import script from "./winningRecord.vue?vue&type=script&lang=js&"
export * from "./winningRecord.vue?vue&type=script&lang=js&"
import style0 from "./winningRecord.vue?vue&type=style&index=0&id=d621f0d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d621f0d2",
  null
  
)

export default component.exports